import { render, staticRenderFns } from "./controller-previous-next-overlay.vue?vue&type=template&id=ff8cf6cc"
import script from "./controller-previous-next-overlay.vue?vue&type=script&lang=js"
export * from "./controller-previous-next-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports